import { RouteObject } from "react-router-dom";
import TermsAndConditionsPage from "ui/user/pages/TermsAndConditionsPage";
import BaseLayout from "../components/layout/BaseLayout/BaseLayout";
import { TermsAndConditionRoutes } from "./TermsAndConditionRouter.types";

export const useTermsAndConditionRoutes = (): RouteObject[] => {
    return [
        {
            path: TermsAndConditionRoutes.ACCEPT_TERMS,
            element: (
                <BaseLayout>
                    <TermsAndConditionsPage />
                </BaseLayout>
            ),
        },
    ];
};
